

















import { Component, Vue } from "vue-property-decorator";

@Component
export default class ImpersonationRibbon extends Vue {
  // Computed
  public get isImpersonating(): boolean {
    return this.$store.getters["auth/isImpersonating"](
      this.$store.state.context
    );
  }
  public get subject(): string {
    const user = this.$store.state.user;
    const string = user.email
      ? `${user.fullname} (${user.email})`
      : user.fullname;
    return string.trim();
  }
}
